"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.router = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_router_dom_1 = require("react-router-dom");
const RootLayout_1 = require("../layouts/RootLayout"); // El layout que creamos
const constants_1 = require("./constants");
const home_1 = require("../pages/home");
const machine_list_1 = require("../pages/machine-list");
const machine_detail_1 = require("../pages/machine-detail");
const machine_configuration_1 = require("../pages/machine-configuration");
const profile_1 = require("../pages/profile");
const products_1 = require("../pages/products");
const ProductsForm_1 = require("../pages/products-form/ProductsForm");
const refills_1 = require("../pages/refills");
const refill_detail_1 = require("../pages/refill-detail");
const orders_1 = require("../pages/orders");
const order_detail_1 = require("../pages/order-detail");
const ClubInvoice_1 = require("../pages/club-invoice/ClubInvoice");
const club_invoice_detail_1 = require("../pages/club-invoice-detail");
const useIsMobile_1 = require("../hooks/mobile/useIsMobile");
const settlement_1 = require("../pages/settlement");
const SettlementDetail_1 = require("../pages/settlement-detail/SettlementDetail");
const advertising_1 = require("../pages/advertising");
const machine_ads_1 = require("../pages/machine-ads");
const HomePageWrapper = () => {
    const isMobile = (0, useIsMobile_1.useIsMobile)();
    return isMobile ? (0, jsx_runtime_1.jsx)(home_1.HomeMobile, {}) : (0, jsx_runtime_1.jsx)(machine_list_1.MachineListPage, { title: "Tus M\u00E1quinas" });
};
exports.router = (0, react_router_dom_1.createBrowserRouter)([
    {
        path: '/',
        element: (0, jsx_runtime_1.jsx)(RootLayout_1.RootLayout, {}),
        children: [
            {
                index: true,
                element: (0, jsx_runtime_1.jsx)(HomePageWrapper, {}),
            },
            {
                path: constants_1.ROUTE_MACHINE_LIST,
                element: (0, jsx_runtime_1.jsx)(machine_list_1.MachineListPage, { title: "Tus M\u00E1quinas" }),
            },
            {
                path: constants_1.ROUTE_MACHINE_DETAIL,
                element: (0, jsx_runtime_1.jsx)(machine_detail_1.MachineDetailPage, { title: "Perfil M\u00F3vil" }),
            },
            {
                path: constants_1.ROUTE_MACHINE_CONFIG,
                element: (0, jsx_runtime_1.jsx)(machine_configuration_1.MachineConfigurationPage, { title: "Configuraci\u00F3n" }),
            },
            {
                path: constants_1.ROUTE_MOBILE_PROFILE,
                element: (0, jsx_runtime_1.jsx)(profile_1.MobileProfile, { title: "Perfil M\u00F3vil" }),
            },
            {
                path: constants_1.ROUTE_PRODUCTS_LIST,
                element: (0, jsx_runtime_1.jsx)(products_1.ProductsPage, { title: "Productos" }),
            },
            {
                path: constants_1.ROUTE_PRODUCTS_CREATE,
                element: (0, jsx_runtime_1.jsx)(ProductsForm_1.ProductsForm, { title: "Crear Producto" }),
            },
            {
                path: constants_1.ROUTE_PRODUCTS_EDIT,
                element: (0, jsx_runtime_1.jsx)(ProductsForm_1.ProductsForm, { title: "Editar Producto" }),
            },
            {
                path: constants_1.ROUTE_REFILLS_LIST,
                element: (0, jsx_runtime_1.jsx)(refills_1.RefillsPage, { title: "Recargas" }),
            },
            { path: constants_1.ROUTE_REFILLS_DETAIL, element: (0, jsx_runtime_1.jsx)(refill_detail_1.RefillDetailPage, {}) },
            { path: constants_1.ROUTE_ORDERS_LIST, element: (0, jsx_runtime_1.jsx)(orders_1.OrdersPage, {}) },
            { path: constants_1.ROUTE_ORDER_DETAIL, element: (0, jsx_runtime_1.jsx)(order_detail_1.OrderDetailPage, {}) },
            { path: constants_1.ROUTE_BILLING_LIST, element: (0, jsx_runtime_1.jsx)(ClubInvoice_1.ClubInvoicePage, {}) },
            { path: constants_1.ROUTE_BILLING_DETAIL, element: (0, jsx_runtime_1.jsx)(club_invoice_detail_1.ClubInvoiceDetailPage, {}) },
            { path: constants_1.ROUTE_SETTLEMENT_LIST, element: (0, jsx_runtime_1.jsx)(settlement_1.SettlementPage, {}) },
            { path: constants_1.ROUTE_SETTLEMENT_DETAIL, element: (0, jsx_runtime_1.jsx)(SettlementDetail_1.SettlementDetailPage, {}) },
            { path: constants_1.ROUTE_ADVERTISING_LIST, element: (0, jsx_runtime_1.jsx)(advertising_1.AdvertisingPage, {}) },
            {
                path: constants_1.ROUTE_ADVERTISING_MACHINE_ADS,
                element: (0, jsx_runtime_1.jsx)(machine_ads_1.MachineAdsPage, {}),
            },
        ],
    },
], {
    basename: constants_1.ROUTE_BASE,
});
